
export const openGlobalLogin = () => {
  // 获取环境变量中的登录重定向URL
  const loginRedirectUrl = window.location.origin + '/loginAuth'

  console.log('loginRedirectUrl:', encodeURIComponent(loginRedirectUrl))
  // window.location.href = 'http://192.168.2.40:9999/third-login?redirect=' + encodeURIComponent(loginRedirectUrl)
  if (window.location.href.indexOf('localhost') === -1) {
    let client = window.location.host.split('.')[0]
    window.location.href = 'http://' + client + '.aishanyin.com/third-login?redirect=' + encodeURIComponent(loginRedirectUrl) + '&domain_alias=' + client

  } else {
    window.location.href = 'http://jiuyao.aishanyin.com/third-login?redirect=' + encodeURIComponent(loginRedirectUrl) + '&domain_alias=' + 'jiuyao'
  }
  // if (env == 'prod') {
  //   let client = window.location.host.split('.')[0].split('-')[1]
  //   window.location.href = 'http://' + client + '.aishanyin.com/third-login?redirect=' + encodeURIComponent(loginRedirectUrl) + '&domain_alias=' + client
  // } else {
  //   window.location.href = 'http://engine.aishanyin.com/third-login?redirect=' + encodeURIComponent(loginRedirectUrl)
  // }
}
